import React, { useContext } from "react";
import PropTypes from "prop-types";
import { env } from "../../properties";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import GenericMenuItem from "./GenericMenuItem";
import CompanySelectorButton from "../common/CompanySelectorButton";
import { ListItem } from "@mui/material";
import { useAuth } from "oidc-react";
import { contactHasRight } from "../../utils/commonFunctions";
import { CustomerContext } from "../../context/CustomerContext";
import Rendered from "../Rendered";

const MenuList = ({ subMenuOpen, handleSubMenuOpen }) => {
  const customerContext = useContext(CustomerContext);
  const auth = useAuth();

  return (
    <List>
      <Rendered rendered={!!auth.userData}>
        <ListItem>
          <CompanySelectorButton />
        </ListItem>
        <Divider />
      </Rendered>
      {env.menuItems.map(menuItem =>
        <Rendered rendered={!!contactHasRight(customerContext.selectedContact.roles, menuItem.access)}>
          <GenericMenuItem
            menuItem={menuItem}
            handleSubMenuOpen={handleSubMenuOpen}
            subMenuOpen={subMenuOpen}
            orientation={"vertical"}
            key={menuItem.key || menuItem.url}
          />
        </Rendered>
      )}
    </List>
  );
};

MenuList.propTypes = {
  handleSubMenuOpen: PropTypes.func.isRequired,
  subMenuOpen: PropTypes.object.isRequired
};

export default MenuList;
